import { requestPost } from '@/common/request';

export enum LinkedType {
  category = 1, // 品类
  situation = 2, // 场景
}

export enum OperateType {
  linked = 1, // 关联
  unLinked = 2, // 取消关联
}

export interface Query {
  search?: string; // 关键字
  groupId?: string | number; // 趋势主张id，用于筛选，本期不做
  page?: number; // 操作类型
  pageSize?: number; // 品类id或场景id列表
  searchType?: number; // 0 分页 1 不分页
}

export interface StageItem {
  stageId: string; //趋势场景id
  stageName: string; //趋势场景名称
  status: string; // 0 下线，1 上线
  skuNum: number; // 主张下面的商品数量
  cateogryNum: number; //品类数
  createErpNo: string; //创建erp
  createTime: string; // 创建时间
  lastUpdateErpNo: string; // 更新erp
  lastUpdateTime: string; // 更新时间
}

type ResultData = {
  list: StageItem[];
};

// 获取趋势场景列表
export default function queryTrendStageList(query: Query): Promise<RequestResult<ResultData>> {
  return requestPost('/generic/materialRpcService/queryTrendStageList', query);
}
